import { useEffect, useState, useContext } from 'react';
import { LawyerContext, LoadingContext } from '../../../partials/Context';
import Chart from 'chart.js/auto'
import {CategoryScale} from 'chart.js';
import DatePickers from './DatePickers';
import StatsSummary from './StatsSummary'
import LineChart from './LineChart'
import {Errors} from '../../../partials/Partials';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

Chart.register(CategoryScale)


function Statistics() {
    let now = new Date()
    let month_start = new Date(now.getFullYear(), now.getMonth(), 1);

    if(now.getDate() === month_start.getDate()) {
        month_start = new Date(now.getFullYear(), now.getMonth()-1, 1);
    }

    const [stats_data, setStats] = useState({});
    const [from_date, setFromDate] = useState(month_start);
    const [to_date, setToDate] = useState(now);
    const [id, setID] = useState(null);
    const {setLoading} = useContext(LoadingContext);
    const [errors, setErrors] = useState([]);
    const lawyer = useContext(LawyerContext); 
    const {is_premium} = lawyer || '';
    let wanted_data = [];

    if (is_premium) {
        wanted_data = {
        'date': '',
        'on_list_displayed': 'Wyświetlenia profilu',
        'site_displayed': 'Kliknięcia w profil',
        'phone_displayed': 'Wyświetleń numeru telefonu',
        'email_displayed': 'Wyświetleń adresu e-mail',
        'website_displayed': 'Wyświetleń adresu www',
        'problem_sent': 'Wysłanych do Ciebie pytań',
        'problem_responded': 'Wysłane przez Ciebie odpowiedzi',
        'problemforum_responded': 'Wysłane odpowiedzi na nieodpłatne pytania',
//        'client_gets_phone': 'Ilość Klientów Infolinii, którzy otrzymali Twój numer',
        'sms_send': 'Ilość wysłanych do Ciebie SMS-ów'
        }
    } else if (is_premium === false) {
        wanted_data = {
        'date': '',
        'on_list_displayed': 'Wyświetlenia profilu',
        'site_displayed': 'Kliknięcia w profil',
        }
    } 
    
    useEffect(() => {
        setLoading(true);
        if(id)
        fetch(`/api/userstats/${id}/?from_date=${from_date.toISOString().slice(0,10)}&to_date=${to_date.toISOString().slice(0,10)}`).then( res => {
            if (res.ok) {
            res.json().then(
                data  => {
                    let stats = {}
                    let keys =  []
                    
                    if (data.stats.length > 0) {
                        Object.keys(data.stats[0]).forEach(item => {
                            if (Object.keys(wanted_data).indexOf(item) !== -1) {
                                keys.push(item)
                            }
                        })
                    
                        keys.forEach(item => stats = {...stats, [item]: []})

                        data.stats.forEach(item => {
                            keys.forEach(key=> {
                                stats[key].push(item[key])
                            })
                        })

                        setStats(stats)
                        setLoading(false)
                    }  else {
                        Object.keys(wanted_data).forEach(item => {
                            keys.push(item)
                        })
                        keys.forEach(key => {
                            stats[key] = [0, 0]
                        })
                        stats['date'] = [from_date.toISOString().slice(0,10), now.toISOString().slice(0,10)]
                        setStats(stats)
                        setLoading(false)
                }
                }
            )} else {
                setErrors(['Nie udało się pobrać danych']);
                setLoading(false)
            }
        })

        fetch(`/api/users/current`).then(res => {
            if (res.ok) {
                res.json().then(data => {
                    setID(data.id)
                    setErrors([])
                })
            } else {
                setErrors(['Nie udało się pobrać danych'])
            }
        })
         // eslint-disable-next-line react-hooks/exhaustive-deps
    },[from_date, to_date, id, is_premium])

    return(
        <div className="stats-container">
            <Errors errors={errors}/>
            <h1 className="stats-title">Statystyki Twojego profilu</h1>
            <DatePickers from_date={from_date} to_date={to_date} setFromDate={setFromDate} setToDate={setToDate}/>
            {is_premium === false ? 
                <div class="statistics-box">
                    <h2>Chcesz więcej wizyt klientów na swoim profilu?</h2>
                    <ul>
                        <li><FontAwesomeIcon icon={faChevronRight}/>odpowiadaj na pytania klientów</li>
                        <li><FontAwesomeIcon icon={faChevronRight}/>pisz artykuły i porady</li>
                        <li><FontAwesomeIcon icon={faChevronRight}/>uzupełnij dokładnie profil</li>
                    </ul>
                </div> : null
            }
            <LineChart stats_data={stats_data} wanted_data={wanted_data}/>
            <StatsSummary stats_data={stats_data} wanted_data={wanted_data} is_premium={is_premium}/>
        </div>
    )
}

export default Statistics;